import React, { useState } from 'react';
import FileUploader from '../components/FileUploader';
import cogoToast from 'cogo-toast';
import { readExcelFile } from '../services/excel-reader-service';

const RollOver = ({ onUpload }) => {

    const [fileData, setFileData] = useState(null);

    const handleFileSelect = async (file) => {
        handleUploadedFile(file);
    };

    const handleFileDrop = (file) => {
        handleUploadedFile(file);
    };

    const handleUploadedFile = (file) => {
        if (file.name.endsWith('.xls') || file.name.endsWith('.xlsx')) {
            readExcelFile(file, 'rxf_number').then((particularColumnData) => {
                if (particularColumnData) {
                    particularColumnData.splice(0, 1);
                    setFileData(particularColumnData);
                }
                else {
                    setFileData(null);
                    const { hide } = cogoToast.error(
                        'No column with "rxf_number" found in uploaded file.',
                        {
                            hideAfter: 15,
                            onClick: () => {
                                hide();
                            },
                        }
                    );
                    return;
                }

            })
                .catch((error) => {
                    setFileData(null);
                    const { hide } = cogoToast.error(
                        error,
                        {
                            hideAfter: 15,
                            onClick: () => {
                                hide();
                            },
                        }
                    );
                    return;
                });
        }
        else {
            const { hide } = cogoToast.error(
                "Files with the extensions '.xls', '.xlsx' can be uploaded.",
                {
                    hideAfter: 15,
                    onClick: () => {
                        hide();
                    },
                }
            );
        }
    }

    const handleUpload = async () => {
        if (!fileData) {
            const { hide } = cogoToast.error(
                "Please Upload RollOver Claims File to Proceed!",
                {
                    hideAfter: 15,
                    onClick: () => {
                        hide();
                    },
                }
            );
            return;
        }

        onUpload(fileData);

        setFileData(null);

    };

    return (
        <div
            className='w-full'
            style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', textAlign: 'center', flexDirection: 'column' }}
        >
            <h1 className='mb-5'>Upload File for RollOvers</h1>
            <FileUploader
                onFileSelect={handleFileSelect}
                onFileDrop={handleFileDrop}
                onUpload={handleUpload}
            />
        </div>
    );
};

export default RollOver;